import { jsx as m } from "react/jsx-runtime";
import { HeaderCell as a } from "./styles.js";
const s = ({ children: e, width: l, align: r, colSpan: t, className: o }) => /* @__PURE__ */ m(a, { colSpan: t, style: { width: l, textAlign: r }, className: o, children: e });
export {
  s as TableHeaderCell
};
//# sourceMappingURL=TableHeaderCell.js.map
